export { default as DashboardRecommendationLinkButton } from './DashboardRecommendationLinkButton';

export type {
  DashboardRecommendationLinkButtonComponent,
  DashboardRecommendationLinkButtonProps,
} from './DashboardRecommendationLinkButton.type';
